import { trackPageViewV2 } from "@/services/analytics-adapter";
import { useEffect } from "react";
import MyDiscountVouchers from "../../components/MyDiscountVouchers";

export default function MyDiscountVouchersPage() {
  useEffect(() => {
    trackPageViewV2({
      pageName: "More:My Discount vouchers",
      pageSubSection1: "More",
      pageSubSection2: "More:My Discount vouchers",
      pageCategory: "More",
    });
  }, []);
  return <MyDiscountVouchers />;
}
